/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
//;
import './Modal.scss';

class ModalContent extends React.Component {
  render() {
    return (
      <div className='custom-modal-content'>
        <div className='container-fluid'>
          <div className='trail-section'> 
            <h1 className='section-title'>{__('Create your school by starting your 14 days free trail now!', 'planDetails')}</h1>
            <div className='section-description'>
              <div className='included-features'>
                <div className='feature-title'>{__('Features that are included in free trial', 'planDetails')}:</div>
                <ul>
                  <li><i className='fa icon-ok check-icon'></i>{__('All basic plan features', 'planDetails')}</li>
                  <li><i className='fa icon-ok check-icon'></i>{__('{amount} Registered Students', 'planDetails', {amount: 80})}</li>
                  <li><i className='fa icon-ok check-icon'></i>{__('{amount} Registered Teachers', 'planDetails', {amount: 40})}</li>
                  <li><i className='fa icon-ok check-icon'></i>{__('{amount} Campus', 'planDetails', {amount: 1})}</li>
                </ul>
              </div>
              <div className='excluded-features'>
                <div className='feature-title'>{__('Features that are NOT included', 'planDetails')}:</div>
                <ul>
                  <li><i className='fa icon-cancel close-icon'></i>{__('No Posters', 'planDetails')}</li>
                  <li><i className='fa icon-cancel close-icon'></i>{__('No Contacts', 'planDetails')}</li>
                  <li><i className='fa icon-cancel close-icon'></i>{__('No Smart Check-in', 'planDetails')}</li>
                  <li><i className='fa icon-cancel close-icon'></i>{__('No Recent Activity Logs', 'planDetails')}</li>
                </ul>
              </div>
            </div>
            <button className="btn btn-primary btn-start-trial" onClick={this.props.onFormChange}>{__('Start My Trial', 'planDetails')}</button>
          </div>
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/StartFreeTrial/ModalContent.js